import wrappedAxios from "../axiosWrapper";
import * as UP from "./urlParsers";
import { fileToAttachment } from "../../utils/files";

export const submitBugReport = async (message: string, files: File[]) =>
  wrappedAxios<void>({
    url: UP.submitBugReport(),
    method: "post",
    data: {
      message,
      attachments: await Promise.all(files.map(fileToAttachment)),
    },
  });

export const submitUserFeedback = async (message: string, files: File[]) =>
  wrappedAxios<void>({
    url: UP.submitUserFeedback(),
    method: "post",
    data: {
      message,
      attachments: await Promise.all(files.map(fileToAttachment)),
    },
  });
